"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _style = _interopRequireDefault(require("./style.css"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _LoginForm = _interopRequireDefault(require("../LoginForm"));
var _RegisterForm = _interopRequireDefault(require("./RegisterForm"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var RegisterLoginForm = function RegisterLoginForm(props) {
  var registerProps = props.registerProps,
    loginProps = props.loginProps;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-sm-6 ".concat(_style["default"].loginContainer, " ").concat(_style["default"].showOnMobile)
  }, /*#__PURE__*/_react["default"].createElement(_LoginForm["default"], loginProps)), /*#__PURE__*/_react["default"].createElement("div", {
    className: 'col-sm-6 ' + _style["default"].registerContainer
  }, /*#__PURE__*/_react["default"].createElement(_RegisterForm["default"], registerProps)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-sm-6 ".concat(_style["default"].loginContainer, " ").concat(_style["default"].showOnDesktop)
  }, /*#__PURE__*/_react["default"].createElement(_LoginForm["default"], loginProps)));
};
RegisterLoginForm.propTypes = {
  registerProps: _propTypes["default"].object,
  loginProps: _propTypes["default"].object
};
var _default = exports["default"] = RegisterLoginForm;